import { render, staticRenderFns } from "./step_manage_add_dialog.vue?vue&type=template&id=0567a85c"
import script from "./step_manage_add_dialog.vue?vue&type=script&lang=js"
export * from "./step_manage_add_dialog.vue?vue&type=script&lang=js"
import style0 from "./step_manage_add_dialog.vue?vue&type=style&index=0&id=0567a85c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports